import { DEFAULT_ANCHORS } from "@baze/catalog";
import type { PageNode, SectionType, WebsiteDefinition } from "@baze/schema";

/** `${type}-${n}` unique across the whole definition (section ids are global). */
export function nextSectionId(def: WebsiteDefinition, type: SectionType): string {
  const used = new Set(def.pages.flatMap((p) => p.sections.map((s) => s.id)));
  let n = 1;
  while (used.has(`${type}-${n}`)) n++;
  return `${type}-${n}`;
}

/** Anchor unique within a page: base, base-2, base-3 … (ids max 64 chars). */
export function uniqueAnchor(page: Pick<PageNode, "sections">, base: string, exceptSectionId?: string): string {
  const used = new Set(page.sections.filter((s) => s.id !== exceptSectionId).map((s) => s.anchor));
  const clean = base.slice(0, 58) || "bagian";
  if (!used.has(clean)) return clean;
  let n = 2;
  while (used.has(`${clean}-${n}`)) n++;
  return `${clean}-${n}`;
}

export function defaultAnchor(type: SectionType, anchors?: Partial<Record<SectionType, string>>): string {
  return anchors?.[type] ?? DEFAULT_ANCHORS[type];
}

export function nextPageId(def: WebsiteDefinition, base: string): string {
  const used = new Set(def.pages.map((p) => p.id));
  const clean = base.replace(/[^a-z0-9-]/g, "").slice(0, 50) || "halaman";
  if (!used.has(clean)) return clean;
  let n = 2;
  while (used.has(`${clean}-${n}`)) n++;
  return `${clean}-${n}`;
}

export function uniquePageSlug(def: WebsiteDefinition, base: string): string {
  const used = new Set(def.pages.map((p) => p.slug));
  const clean = "/" + (base.replace(/^\/+/, "").replace(/[^a-z0-9-]/g, "").slice(0, 40) || "halaman");
  if (!used.has(clean)) return clean;
  let n = 2;
  while (used.has(`${clean}-${n}`)) n++;
  return `${clean}-${n}`;
}

/** URL-safe slug from a free-text title. */
export function slugifyTitle(title: string): string {
  return title
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 40);
}
